<button
  class="acc-header"
  type="button"
  [class.toggled]="showBody"
  (click)="toggle()"
  buttonTap
  [highlightStyle]="highlightStyle"
  [highlightInsetY]="highlightInsetY"
  [highlightInsetX]="highlightInsetX">
  <ng-content select="[accHeader]"></ng-content>
  <p class="text-start position-relative" [innerHTML]="title"></p>
  @if (showArrow) {
    <app-icon class="acc-arrow" [icon]="icon"></app-icon>
  }
</button>

<div class="acc-body" *ngIf="showBody" [@collapse]="{ value: true, params: { durationMs: $durationMs() } }">
  <div class="acc-content">
    <ng-content></ng-content>
  </div>
</div>

<div class="bottom-cap"></div>